import { Component, OnInit } from "@angular/core";
import { SDContact } from "../../../Models/StaticData/contact";
import { UserConfigService } from "src/app/Services/AuthService/user-config.service";
import { IUserConfig } from "src/app/Models/Interface/Auth/user-config";
import { CurrencyService } from "src/app/Services/CurrencyService/currency.service";
import { ICurrencyResponse } from "src/app/Models/Interface/Currency/currency-response";
import { EAccountType } from "src/app/Models/Enum/account-type";
import { CookieService } from "ngx-cookie-service";
import { UserDetailsService } from "src/app/Components/Services/user-details.service";
import { EUserPermission } from "src/app/Models/Enum/user-permission";
import { StorageOrderService } from "src/app/Services/ShopService/StorageOrder/storage-order.service";
import { ConfirmationComponent } from "src/app/Components/Dialoges/ResponseDIaloges/confirmation/confirmation.component";
import { ECommonStatus } from "src/app/Models/Enum/common-status";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { VideoWorkComponent } from "../../Dialoges/video-work/video-work.component";
import { EUserGuide } from "src/app/Models/Enum/user-guide";

@Component({
  selector: "app-super-nav-bar",
  templateUrl: "./super-nav-bar.component.html",
  styleUrls: ["./super-nav-bar.component.scss"],
})
export class SuperNavBarComponent implements OnInit {
  contact = SDContact;
  selectedCurrency: ICurrencyResponse = {} as ICurrencyResponse;
  user = {} as IUserConfig;
  currencies: ICurrencyResponse[] = [];
  accountType = EAccountType;
  permission = EUserPermission;

  constructor(
    private userConfigService: UserConfigService,
    private currencyService: CurrencyService,
    public userDetailsService: UserDetailsService,
    private storageOrderService: StorageOrderService,
    public dialog: MatDialog,
    private router: Router,
    private cookieService: CookieService
  ) {
    this.userConfigService.getUserConfig().subscribe((res) => {
      this.user = res;
    });
  }

  ngOnInit(): void {
    if (this.user.isLoggedIn) {
      this.getCurrencyList();
    }
  }

  onSelectCurrency(currency: ICurrencyResponse): void {
    if (this.selectedCurrency.name !== currency.name) {
      if (this.storageOrderService.getOrder()?.orderId) {
        const dialogRef = this.dialog.open(ConfirmationComponent, {
          maxHeight: "90vh",
          data: {
            materialIcon: "warning_amber",
            header: "Are You Sure?",
            subTitle: `${this.storageOrderService.getOrder().orderNumber} Is ${
              this.selectedCurrency.name
            } Please confirm to remove the order`,
            iconClassCss: "text-danger",
            buttonClassCss: "btn-danger",
            successButtonName: "Confirm",
          },
        });
        dialogRef.afterClosed().subscribe((res) => {
          if (res) {
            if (this.router.url.includes("shop")) {
              this.router.navigate(["dashboard"]);
            }
            this.storageOrderService.removeOrderFromLocalStorage();
            this.currencyService.currencyOBJ.currencyId = currency.id;
            this.currencyService.currencyOBJ.userId = this.user.userId;
            this.currencyService.updateCurrency().subscribe(
              (res) => {
                if (res) {
                  this.selectedCurrency = currency;
                }
              },
              (error) => {},
              () => {
                this.updateUser(
                  this.selectedCurrency.id,
                  this.selectedCurrency.code
                );
              }
            );
          }
        });
      } else {
        this.currencyService.currencyOBJ.currencyId = currency.id;
        this.currencyService.currencyOBJ.userId = this.user.userId;
        this.currencyService.updateCurrency().subscribe(
          (res) => {
            if (res) {
              this.selectedCurrency = currency;
            }
          },
          (error) => {},
          () => {
            this.updateUser(
              this.selectedCurrency.id,
              this.selectedCurrency.code
            );
          }
        );
      }
    }
  }

  currencyActivation(currency: ICurrencyResponse): boolean {
    return this.selectedCurrency === currency;
  }

  getCurrencyList(): void {
    this.currencyService.getCurrencies().subscribe(
      (res) => {
        this.currencies = res;

        // set currencyList in local storage
        localStorage.setItem("currencyList", JSON.stringify(res));
      },
      (error) => {},
      () => {
        // @ts-ignore
        this.selectedCurrency = this.currencies.find(
          (c) => c.id === this.user.currencyId
        );
      }
    );
  }

  updateUser(id: number, code: string): void {
    if (sessionStorage.getItem("token")) {
      sessionStorage.setItem("currencyId", String(id));
      sessionStorage.setItem("currencyCode", code);
      this.userConfigService.setUserConfig({
        accountId: Number(sessionStorage.getItem("accountId")),
        isSuperAdmin: sessionStorage.getItem("isSuperAdmin"),
        accountTypeCode: String(sessionStorage.getItem("accountTypeCode")),
        name: String(sessionStorage.getItem("fullName")),
        companyName: String(sessionStorage.getItem("companyName")),
        currencyCode: String(sessionStorage.getItem("currencyCode")),
        profileImg: sessionStorage.getItem("profilePicturePath"),
        isLoggedIn: true,
        token: String(sessionStorage.getItem("token")),
        emailAddress: String(sessionStorage.getItem("emailAddress")),
        currencyId: Number(sessionStorage.getItem("currencyId")),
        userId: Number(sessionStorage.getItem("userId")),
        roleCode: String(sessionStorage.getItem("roleCode")),
        roleId: Number(sessionStorage.getItem("roleId")),
        // @ts-ignore
        userPermissionsLists: JSON.parse(
          sessionStorage.getItem("userPermissionsLists")!
        ),
        // @ts-ignore
        displayBoardingVideo: JSON.parse(
          sessionStorage.getItem("displayBoardingVideo")!
        ),
      });
      window.location.reload();
    } else if (this.cookieService.get("token")) {
      this.cookieService.set("currencyId", String(id), undefined, "/");
      this.cookieService.set("currencyCode", code, undefined, "/");
      this.userConfigService.setUserConfig({
        accountId: Number(this.cookieService.get("accountId")),
        isSuperAdmin: this.cookieService.get("isSuperAdmin"),
        accountTypeCode: this.cookieService.get("accountTypeCode"),
        name: this.cookieService.get("fullName"),
        companyName: this.cookieService.get("companyName"),
        token: this.cookieService.get("token"),
        profileImg: this.cookieService.get("profilePicturePath"),
        currencyCode: this.cookieService.get("currencyCode"),
        isLoggedIn: true,
        emailAddress: this.cookieService.get("emailAddress"),
        currencyId: Number(this.cookieService.get("currencyId")),
        userId: Number(this.cookieService.get("userId")),
        roleCode: this.cookieService.get("roleCode"),
        roleId: Number(this.cookieService.get("roleId")),
        userPermissionsLists: JSON.parse(
          this.cookieService.get("userPermissionsLists")
        ),
        displayBoardingVideo: JSON.parse(
          this.cookieService.get("displayBoardingVideo")
        ),
      });
      window.location.reload();
    }
  }

  onShowVideo(): void {
    //TODO:: need to change video link, disabling for now
    const dialogRef = this.dialog.open(VideoWorkComponent, {
      minWidth: "50vw",
      maxWidth: "80vw",
      maxHeight: "90vh",
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res === EUserGuide.NEED_HELP) {
        let x = {
          userId: this.user.userId,
          userName: this.user.name,
          userEmail: this.user.emailAddress,
        };
      }
    });
  }
}
